@switch (template) { @case ('external') {
<a
  [ngClass]="linkclass ? linkclass : ''"
  [href]="to"
  target="_blank"
  rel="noopener noreferrer"
  [attr.disabled]="disabled">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} @case ('internal') {

  @if (target === '_blank') {
    <a
      [ngClass]="linkclass ? linkclass : ''"
      [href]="getFullInternalUrl()"
      target="_blank"
      rel="noopener noreferrer"
      [attr.disabled]="disabled">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  }

  @if (target !== '_blank') {
    <a
      [ngClass]="linkclass ? linkclass : ''"
      [routerLink]="url"
      [queryParams]="tree.queryParams"
      [fragment]="tree.fragment"
      [attr.disabled]="disabled">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  }

} @case ('falseInternal') {
<a [ngClass]="linkclass ? linkclass : ''" [href]="to">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} @case ('noRoute') {
<a [ngClass]="linkclass ? linkclass : ''">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} @case ('newTab') {
<a
  [ngClass]="linkclass ? linkclass : ''"
  [routerLink]="to"
  target="_blank"
  rel="noopener noreferrer"
  [attr.disabled]="disabled">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} }

<div class="link-icon -parent">
  <ng-template #content>
    <div class="link-icon -parent -text">
      <ng-content></ng-content>
    </div>
    <icon [icon]="icon" [ngClass]="iconclass !== undefined ? iconclass : ''">
    </icon>
  </ng-template>
</div>
